import { Cursor } from 'js/types';

export const findCursorById = (cursors: Record<string, Cursor>, cursorId: number) => {
  return (
    Object.values(cursors)
      .flat()
      .find(cursor => cursor.id === cursorId)
  );
};
